import {
  Bereavement,
  CarePlanFrequency,
  CarePlanProblems,
  Measures,
  ClearScripts,
  ProgressNotes,
  DocLink,
  Facesheet,
  PatientAssistance,
} from '@mummssoftware/utils/constants';
import {
  SocialWorker as socialWorker,
  SW,
  LCSW,
  CISW,
} from '@mummssoftware/utils/roleData';
export const WIDGET_CONFIG = 'WIDGET_CONFIG';
export const FORM_NAME = 'FORM_NAME';
// DASHBOARD CONTEXT
export const SET_ALERT = 'Dashboard.SET_ALERT';
export const SET_DISABLE_PRINT = 'Dashboard.SET_DISABLE_PRINT';
export const SET_IDG_MEETING_CONTENT = 'Dashboard.SET_IDG_MEETING_CONTENT';
export const SET_PRINT_INTERFACE_OPEN = 'Dashboard.SET_PRINT_INTERFACE_OPEN';
export const SET_PRINT_LAYOUT_OPEN = 'Dashboard.SET_PRINT_LAYOUT_OPEN';
export const SET_PRINT_CONFIG = 'Dashboard.SET_PRINT_CONFIG';
export const ADD_WIDGET_READY = 'Dashboard.ADD_WIDGET_READY';
export const RESET_WIDGETS_READY = 'Dashboard.RESET_WIDGETS_READY';
export const SET_LOADER = 'Dashboard.SET_LOADER';
export const SET_THEME_OVERLAY = 'Dashboard.SET_THEME_OVERLAY';
export const REFRESH_DASHBOARD = 'Dashboard.REFRESH_DASHBOARD';
export const SET_DASHBOARD_READY = 'Dashboard.SET_DASHBOARD_READY';

// VISIT CONTEXT
export const OPEN_VISIT_WIDGET = 'Visit.OPEN_VISIT_WIDGET';
export const GET_ROLE_GROUPS = 'Visit.GET_ROLE_GROUPS';
export const SET_ACTING_AS_ROLE = 'Visit.SET_ACTING_AS_ROLE';
export const SET_PREP_VISIT = 'Visit.SET_PREP_VISIT';
export const SET_SAVED_VISIT = 'Visit.SET_SAVED_VISIT';
export const SET_INITIAL_SAVED_VISIT = 'Visit.SET_INITIAL_SAVED_VISIT';
export const GET_TIME = 'Visit.GET_TIME';
export const SET_TIME = 'Visit.SET_TIME';
export const SET_EDIT_TIME = 'Visit.SET_EDIT_TIME';
/**
 * Dispatched from VisitContextProvider when the visit widget is open, `savedVisit.id` matches
 * `appVisit.id`, and `appVisit.id` has not yet been hydrated for this session (ref-guarded).
 * Reducer: timer HH:MM if still 00:00; fee fields only where context is still null.
 */
export const HYDRATE_EDIT_FIELDS_FROM_VISIT =
  'Visit.HYDRATE_EDIT_FIELDS_FROM_VISIT';
export const SET_CC_TIME = 'Visit.SET_CC_TIME';
export const SET_MILEAGE = 'Visit.SET_MILEAGE';
export const SET_TOLLS_FEES = 'Visit.SET_TOLLS_FEES';
export const SET_TRANSIT_FEES = 'Visit.SET_TRANSIT_FEES';
export const SET_TRAVEL_TIME = 'Visit.SET_TRAVEL_TIME';
export const SET_VISIT_TITLE = 'Visit.SET_VISIT_TITLE';
export const MINIMIZE_VISIT_DIALOG = 'Visit.MINIMIZE_VISIT_DIALOG';
export const SET_VISIT_ERROR = 'Visit.SET_VISIT_ERROR';
export const SHOW_TASKS = 'Visit.SHOW_TASKS';
export const SET_VISIT_ALERT = 'Visit.SET_VISIT_ALERT';
export const SET_IPU_VISIT = 'Visit.SET_IPU_VISIT';
export const SET_IPU_VISIT_CREATED = 'Visit.SET_IPU_VISIT_CREATED';
export const SET_FACE_TO_FACE = 'Visit.SET_FACE_TO_FACE';
export const SET_IPU_RADIO_CHOICE = 'Visit.SET_IPU_RADIO_CHOICE';
export const SHOW_CONFIRM_VISIT = 'Visit.SHOW_CONFIRM_VISIT';
export const STOP_VISIT = 'Visit.STOP_VISIT';
export const ADD_TASK = 'Visit.ADD_TASK';
export const DELETE_TASK = 'Visit.DELETE_TASK';
export const RESET_TASKS = 'Visit.RESET_TASKS';
export const SET_HOPE_VISIT_WARNING = 'Visit.SET_HOPE_VISIT_WARNING';
export const SET_VISIT_EPISODE = 'Visit.SET_VISIT_EPISODE';
/** Set when visit-log reopens a visit; RecordVisit clears after hydrate + details fetch. */
export const SET_OPENED_FROM_VISIT_LOG_REOPEN =
  'Visit.SET_OPENED_FROM_VISIT_LOG_REOPEN';
/** Epoch ms when document-on-visit session started (visit-log hydrate or cold load). */
export const SET_DOCUMENT_SESSION_STARTED_AT =
  'Visit.SET_DOCUMENT_SESSION_STARTED_AT';
/** True while document-on-visit close PUT runs; keeps VisitInterface on loader until reset. */
export const SET_CLOSING_PRIOR_VISIT = 'Visit.SET_CLOSING_PRIOR_VISIT';

// HCPCS CONTEXT
export const SET_HCPCS_CHOICE = 'HCPCS.SET_HCPCS_CHOICE';
export const DELETE_HCPCS_CHOICE = 'HCPCS.DELETE_HCPCS_CHOICE';
export const DISABLE_HCPCS_MENU = 'HCPCS.DISABLE_HCPCS_MENU';
export const DELETE_ICD_CODE = 'HCPCS.DELETE_ICD_CODE';
export const ADD_ICD_CODE = 'HCPCS.ADD_ICD_CODE';
export const ADD_SAVED_ICD_CODE = 'HCPCS.ADD_SAVED_ICD_CODE';
export const SET_ICD_SECTION = 'HCPCS.SET_ICD_SECTION';
export const SET_HCPCS_DURATION = 'HCPCS.SET_HCPCS_DURATION';
export const SET_SHOW_HCPCS = 'HCPCS.SET_SHOW_HCPCS';
export const SET_HCPCS_ERROR = 'HCPCS.SET_HCPCS_ERROR';
export const SET_SUBMIT_HCPCS_ERROR = 'HCPCS.SET_SUBMIT_HCPCS_ERROR';
export const SET_HCPCS_CODE_MAP = 'HCPCS.SET_HCPCS_CODE_MAP';
export const RECORD_DATA = 'HCPCS.RECORD_DATA';
export const RESET_HCPCS = 'HCPCS.RESET_HCPCS';
/** Clear HCPCS choices/duration/ICD state only; keep `showHCPCS` (dialog stays open when loading saved `physicianServices`). */
export const RESET_HCPCS_FOR_RELOAD = 'HCPCS.RESET_HCPCS_FOR_RELOAD';
export const SHOW_VISIT_LOADER = 'HCPCS.SHOW_VISIT_LOADER';

// general constants
export const SocialWorker = socialWorker;
export const Phone = 'Phone';
export const InPerson = 'In Person';
export const Telehealth = 'Telehealth';
export const InProgress = 'In Progress';
export const InProgressDriving = 'In Progress Driving';
export const Completed = 'Completed';
export const Refused = 'Refused';

export const RTN = 'RTN';
export const CC = 'CC';
export const GIP = 'GIP';
export const RSP = 'RSP';
export const IPU = 'IPU';

export const Direct = 'Direct';
export const Billable = 'Billable';
export const NonBillable = 'NonBillable';

export const DirectCare = 'DIRECT_CARE';
export const PhoneCall = 'PHONE_CALL';
export const TelehealthType = 'TELEHEALTH';

export const PrintTheChart = 'Print the Chart';

export const SocialWorkerRoles = [SW, LCSW, CISW];

export type OptionType = {
  label: string;
  value: string;
  id: string | number;
  key?: string;
  qcode?: string;
};

export const allowedRoles = [socialWorker];

export const levelOfCares: OptionType[] = [
  { label: 'Routine Home Care', value: 'ROUTINE', id: RTN },
  {
    label: 'Continuous Care',
    value: 'CONTINUOUS_CARE',
    id: CC,
  },
  {
    label: 'General Inpatient',
    value: 'GENERAL_IN_PATIENT',
    id: GIP,
  },
  {
    label: 'Respite Care',
    value: 'RESPITE',
    id: RSP,
  },
];
export const pouchDBName = 'dashboard';
export const patientDashboard = 'patientDashboard';
export const clinicalDashboard = 'clinicalDashboard';
export const patientPortal = 'patientPortal';
export const idgMeetingName = 'idgMeetingName';

export const SCIPU = 'SC:IPU';
export const LOCMap = {
  ROUTINE: RTN,
  CONTINUOUS_CARE: CC,
  GENERAL_IN_PATIENT: GIP,
  RESPITE: RSP,
};

export const CompletedPDFComponents: mumms.ComponentName[] | string[] = [
  Measures,
  CarePlanFrequency,
  CarePlanProblems,
  ProgressNotes,
  DocLink,
  ClearScripts,
  Bereavement,
  Facesheet,
  PatientAssistance,
];
